export default __webpack_public_path__ + "src/assets/icn-show-closed-eye-svg.e75d54bbf125672a85b2704a40d77cc1.svg";